import { locationApis } from "../../components/pages/location/LocationRoute";
import { officesApis } from "../../components/pages/offices/OfficesRoutes";
import {
  API_USERS,
  API_ACCOUNTS_ROLES,
  API_CONFIGURABLES,
  API_ACCOUNTS_PROFILES,
  // API_AUDIT_ACTIVITY,
  API_LOAN_APPLICATIONS,
  API_INTEREST_CONFIGURABLES,
  API_PERIOD_CONFIGURABLES,
  API_FEES_CONFIGURABLES,
  API_LEDGERS,
  API_CHARTS_OF_ACCOUNTS,
  API_SUPPLIER_CONFIGURABLES,
  API_PURCHASE_ORDERS,
  API_INVENTORY,
  API_PURCHASE_ORDER_ITEMS,
  API_PRODUCTS,
  API_PAYROLL,
  API_ALLOWANCE_TYPE_CONFIGURABLES,
  API_EXPENSES,
  API_OTHER_INCOME,
  API_ORGANISATIONS,
  API_INVOICES,
  API_PRNS,
  API_REQUISITIONS,
  API_LOAN_APPLICATIONS_DRAFTS,
  API_PAYMENTS,
  API_LOAN_APPLICATIONS_RESCHEDULE,
  API_BULK_PURCHASE_ORDERS,
  API_PAYMENT_MODES_CONFIGURABLES,
  API_APPLICATION_USERS,
  // API_PAYMENT_ITEM,
  API_YOYA_CHARGES,
  API_PARTNERS,
  API_MECHANT_FEES,
  API_PARTNER_CHARGES,
  API_UTILITY_LOGS,
  API_PAYMENT_SERVICE,
  API_WALLET_TRANSACTIONS,
  API_WALLET_DEPOSIT,
  API_REVERSE_TRANSACTIONS,
  API_WALLET_TRANSFER,
  API_PAYMENT_TYPES,
  API_MARK_TRANSACTION,
  API_PARTNER_ITEM_MAPPING,
  API_LIQUIDATIONS,
  API_WORKFLOWS,
  API_SCRUTNIY_WORKFLOWS,
  API_MERCHANT_SERVICE_ACCESS,
  API_CHARGE_ASSIGNMENT,
  API_RECONCILIATIONS_REPORTS,
  API_INTERNAL_MERCHANT_ACCESS,
  API_MERCHANT_USERS_LIST,
  API_TRANSACTION_MONITORING,
  API_RECONCILIATION_STATEMENTS,
  API_SYSTEM_WALLETS,
  API_LIQUIDATIONS_CONFIGURABLE,
  API_QR_CODE,
  API_MERCHANT_CODES,
  API_FRAUD_RULES,
  API_QR_CODE_PAYMENTS,
  API_FRAUD_EVENTS,
  API_FRAUD_RULES_HISTORY,
  API_MERCHANT_PAYMENTS,
  API_FRAUD_AUDIT_LOGS,
  API_FRAUD_WEIGHT_SCORE,
  API_FRAUD_ALERTS,
  API_FRAUD_CASES,
  API_FRAUD_RULE_TEMPLATES,
  API_FRAUD_CONFIGURATIONS,
  API_REJECTED_APPLICATION_USERS,
  API_MERCHANT_IP_WHITELIST,
  API_IFRAME_PAYMENTS,
  API_SET_USSD_MERCHANT,
  API_USSD_INPUT_LOGS,
  API_USSD_CUSTOMER_TRANSACTIONS,
  API_USSD_INCOMING_LOGS,
  API_USSD_OUTGOING_LOGS,
  API_USSD_CONFIGURABLES,
  API_ENQUIRIES,
  API_MONITORED_ACCOUNTS,
  API_ACCOUNT_ALERTS,
  API_CREDIT_HOLDING_TYPES,
  API_DEBIT_HOLDINGS_TYPES,
  API_LIQUIDATION_BANK_CODES,
  TRIAL_BALANCE_API,
  TRANSACTION_CHANNEL_SEPARATION_API,
  API_BANK_ACCOUNTS,
  API_REPLENISHMENT,
  API_DEBIT_HOLDINGS,
  API_CREDIT_HOLDINGS,
  API_COMPOSITE_ITEMS,
  PARTNER_DAILY_COMMISSIONS_REPORT_API,
  AGENT_DAILY_COMMISSIONS_REPORT_API,
  YOYA_DAILY_COMMISSIONS_REPORT_API,
  API_UPDATE_PAYMENT_ITEM,
  API_FLOAT_INTEREST_CONFIGS,
  API_FLOAT_INTEREST_STATEMENTS,
  API_SETTLEMENT_ELIGIBILITY,
  API_SETTLEMENT_BATCHES,
  API_SETTLEMENT_RULES,
  API_SETTLEMENT_BENEFICIARIES,
  API_SETTLEMENT_APPROVALS,
  API_SECURITY_ACTIVITY,
  API_BUSINESS_AUDIT_LOGS,
  INCIDENT_TICKETING_API,
  API_TICKET_CATEGORIZATION,
  RAISED_TICKETS_API,
  ASSIGNED_TICKETS_API,
  INCIDENT_TICKET_CATEGORY_REPORT,
  INCIDENT_TICKET_SEVERITY_REPORT,
  API_USSD_SAFEGUARDS,
} from "../../utils/apis";

export const sourceApis: Record<string, string> = {
  users: API_USERS,
  agents: `${API_USERS}?role_name=agent`,
  merchants: `${API_USERS}?role_name=merchant`,
  public_users: `${API_USERS}?role_name=public`,
  application_users: API_APPLICATION_USERS,
  rejected_application_users: API_REJECTED_APPLICATION_USERS,
  staff_users: `${API_USERS}?is_staff=true`,
  // ROLES
  roles: API_ACCOUNTS_ROLES,
  // TRANSACTION PROCESSING
  reverse_transactions: API_REVERSE_TRANSACTIONS,
  mark_transaction: API_MARK_TRANSACTION,
  partner_item_mapping: API_PARTNER_ITEM_MAPPING,
  liquidations: API_LIQUIDATIONS,
  monitored_accounts: API_MONITORED_ACCOUNTS,
  account_alerts: API_ACCOUNT_ALERTS,
  credit_holding_types: API_CREDIT_HOLDING_TYPES,
  debit_holdings_types: API_DEBIT_HOLDINGS_TYPES,
  liquidation_bank_codes: API_LIQUIDATION_BANK_CODES,
  bank_accounts: API_BANK_ACCOUNTS,
  debit_holdings: API_DEBIT_HOLDINGS,
  credit_holdings: API_CREDIT_HOLDINGS,
  // CONFIGURABLES
  configurables: API_CONFIGURABLES,
  interest_configurables: API_INTEREST_CONFIGURABLES,
  period_configurables: API_PERIOD_CONFIGURABLES,
  fees_schedule_configurables: API_FEES_CONFIGURABLES,
  charts_of_accounts_configurables: API_CHARTS_OF_ACCOUNTS,
  supplier_configurables: API_SUPPLIER_CONFIGURABLES,
  allowance_types_configurables: API_ALLOWANCE_TYPE_CONFIGURABLES,
  payment_modes_configurables: API_PAYMENT_MODES_CONFIGURABLES,
  // MASTER DATA APIS
  ...locationApis,
  // USER PROFILE
  profile: API_ACCOUNTS_PROFILES,
  // AUDIT ACTIVITY
  // audit_activity: API_AUDIT_ACTIVITY,
  security_activity: API_SECURITY_ACTIVITY,
  business_audit_logs: API_BUSINESS_AUDIT_LOGS,

  loan_application: API_LOAN_APPLICATIONS,
  loan_application_drafts: API_LOAN_APPLICATIONS_DRAFTS,
  loan_application_reschedule: API_LOAN_APPLICATIONS_RESCHEDULE,
  ledgers: API_LEDGERS,
  expenses: API_EXPENSES,
  requisitions: API_REQUISITIONS,
  other_income: API_OTHER_INCOME,
  invoices: API_INVOICES,
  prns: API_PRNS,
  // INVENTORY MANAGEMENT
  purchase_order: API_PURCHASE_ORDERS,
  purchase_order_actions: API_PURCHASE_ORDERS,
  bulk_purchase_order: API_BULK_PURCHASE_ORDERS,
  purchase_order_items: API_PURCHASE_ORDER_ITEMS,

  inventory: API_INVENTORY,
  products: API_PRODUCTS,
  // PAYROLL MANAGEMENT
  payrolls: API_PAYROLL,
  // OFFICES
  ...officesApis,
  // ADHOC REPORTS
  // SERVICES
  payment_items: API_UPDATE_PAYMENT_ITEM,
  partners: API_PARTNERS,
  merchant_fees: API_MECHANT_FEES,
  merchant_service_access: API_MERCHANT_SERVICE_ACCESS,
  // CHARGES
  yoya_charges: API_YOYA_CHARGES,
  partner_charges: API_PARTNER_CHARGES,
  //PAYMENTS
  payments: API_PAYMENTS,
  composite_items: API_COMPOSITE_ITEMS,

  // ORGANISATIONS
  organisations: API_ORGANISATIONS,

  //REPORTS
  utility_logs: API_UTILITY_LOGS,

  //PAYMENT SERVICES
  payment_services: API_PAYMENT_SERVICE,

  //WALLET TRANSFER
  wallet_transfers: API_WALLET_TRANSACTIONS,
  wallet_transfer: API_WALLET_TRANSFER,
  wallet_deposit: API_WALLET_DEPOSIT,

  //PAYMENT TYPES
  payment_types: API_PAYMENT_TYPES,

  // FLOAT MANAGEMENT
  replenishment: API_REPLENISHMENT,

  //WORKFLOWS
  workflows: API_WORKFLOWS,
  scrutiny_workflows: API_SCRUTNIY_WORKFLOWS,
  merchant_ip_whitelist: API_MERCHANT_IP_WHITELIST,
  charge_assignment: API_CHARGE_ASSIGNMENT,

  //RECONCILIATIONS REPORTS
  reconciliations_reports: API_RECONCILIATIONS_REPORTS,

  // PAYMENT ACCESS MATRIX
  internal_merchant_access: API_INTERNAL_MERCHANT_ACCESS,

  //MERCHANT USERS
  merchant_users: API_MERCHANT_USERS_LIST,
  transaction_monitoring: API_TRANSACTION_MONITORING,
  reconciliation_statements: API_RECONCILIATION_STATEMENTS,

  system_wallets: API_SYSTEM_WALLETS,
  //FINANCE AND TREASURY
  settlement_eligibility: API_SETTLEMENT_ELIGIBILITY,
  float_interest_configs: API_FLOAT_INTEREST_CONFIGS,
  float_interest_statements: API_FLOAT_INTEREST_STATEMENTS,
  settlement_batches: API_SETTLEMENT_BATCHES,
  settlement_rules: API_SETTLEMENT_RULES,
  settlement_beneficiaries: API_SETTLEMENT_BENEFICIARIES,
  settlement_approvals: API_SETTLEMENT_APPROVALS,

  utility_transactions: API_WALLET_TRANSACTIONS,

  //LIQUIDATIONS CONFIGURABLES
  liquidation_configurations: API_LIQUIDATIONS_CONFIGURABLE,

  // QR CODES
  static_qr_code: API_QR_CODE,
  dynamic_qr_code: API_QR_CODE,
  qr_code_payments: API_QR_CODE_PAYMENTS,

  //MERCHANT CODES
  merchant_codes: API_MERCHANT_CODES,
  // FRAUD DETECTION
  fraud_rules: API_FRAUD_RULES,
  fraud_events: API_FRAUD_EVENTS,
  fraud_rules_history: API_FRAUD_RULES_HISTORY,
  fraud_audit_logs: API_FRAUD_AUDIT_LOGS,
  fraud_weight_score: API_FRAUD_WEIGHT_SCORE,
  fraud_alerts: API_FRAUD_ALERTS,
  fraud_cases: API_FRAUD_CASES,
  fraud_templates: API_FRAUD_RULE_TEMPLATES,
  fraud_configurations: API_FRAUD_CONFIGURATIONS,

  //MERCHANT PAYMENTS
  merchant_payments: API_MERCHANT_PAYMENTS,

  //IFRAME PAYMENTS
  iframe_payments: API_IFRAME_PAYMENTS,

  //USSD SERVICES
  set_ussd_merchant: API_SET_USSD_MERCHANT,
  ussd_input_logs: API_USSD_INPUT_LOGS,
  ussd_customer_transactions: API_USSD_CUSTOMER_TRANSACTIONS,
  ussd_incoming_logs: API_USSD_INCOMING_LOGS,
  ussd_outgoing_logs: API_USSD_OUTGOING_LOGS,
  ussd_configurables: API_USSD_CONFIGURABLES,
  ussd_safeguards: API_USSD_SAFEGUARDS,

  //SUMMARY
  partner_commission_summary: PARTNER_DAILY_COMMISSIONS_REPORT_API,
  agent_commission_summary: AGENT_DAILY_COMMISSIONS_REPORT_API,
  yoya_commissio_summary: YOYA_DAILY_COMMISSIONS_REPORT_API,

  //REPORTS
  trial_balance: TRIAL_BALANCE_API,
  transaction_channel_separation: TRANSACTION_CHANNEL_SEPARATION_API,
  incident_ticket_category: INCIDENT_TICKET_CATEGORY_REPORT,
  incident_ticket_severity: INCIDENT_TICKET_SEVERITY_REPORT,

  //ENQUIRIES
  enquiries: API_ENQUIRIES,

  //SUPPORT
  incident_ticketing: INCIDENT_TICKETING_API,
  ticket_categorization: API_TICKET_CATEGORIZATION,
  raised_tickets: RAISED_TICKETS_API,
  assigned_tickets: ASSIGNED_TICKETS_API,
};
